import React from 'react';
import { Field } from 'redux-form';
import { NumberInput, required, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  fields: {
    width: '60%'
  },
  small_fields: {
    width: 300
  }
});

const ValidateRequired = required();

type Props = {
  classes: any,
  record?: any
};

const SettingsTab = (props: Props) => (
  <div>
    <Field name="order" source="order" component={NumberInput} label="Order" step={1.0} /><br />
    <Field name="name" source="name" component={TextInput} label="Name *" validate={ValidateRequired} className={props.classes.fields} /><br />
    <Field name="adsize" source="adsize" component={TextInput} label="Ad Size *" validate={ValidateRequired} className={props.classes.fields} /><br />
    <Field name="rtb_target" source="rtb_target" component={NumberInput} label="RTB ID *" validate={ValidateRequired} step={1.0} /><br />
    <Field name="report_id" source="report_id" component={TextInput} label="Report ID" className={props.classes.small_fields} /><br />
    <Field name="adsense_slot_id" source="adsense_slot_id" component={TextInput} label="Adsense Slot ID" className={props.classes.small_fields} />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/AdSizes/Partials/SettingsTab.tsx